import {
  CmpInvoiceKindEnum,
  CmpOperationalSourceKindEnum,
} from "../../../../graphql/types";

// Mirror of cap-backend getSourceKindForInvoice for membership invoices: an
// invoice saved before sourceKind existed is still a membership invoice when
// its kind is Application or Renewal.
export const isManageInvoiceMembershipSource = ({
  invoiceKind,
  sourceKind,
}: {
  invoiceKind?: CmpInvoiceKindEnum | null;
  sourceKind?: CmpOperationalSourceKindEnum | null;
}) =>
  sourceKind
    ? sourceKind === CmpOperationalSourceKindEnum.MemberApplication ||
      sourceKind === CmpOperationalSourceKindEnum.MemberRenewal
    : invoiceKind === CmpInvoiceKindEnum.Application ||
      invoiceKind === CmpInvoiceKindEnum.Renewal;

export const hasManageInvoiceLifecycleLinkedSource = ({
  eventRegistrationId,
  eventSponsorshipRequestId,
  invoiceKind,
  sourceKind,
}: {
  chamberMemberId?: string | null;
  eventRegistrationId?: string | null;
  eventSponsorshipRequestId?: string | null;
  invoiceKind?: CmpInvoiceKindEnum | null;
  sourceKind?: CmpOperationalSourceKindEnum | null;
}) =>
  Boolean(
    eventRegistrationId ||
    eventSponsorshipRequestId ||
    isManageInvoiceMembershipSource({ invoiceKind, sourceKind }),
  );
